import {
    SYSTEM_CHOOSE_CURRENT_POSITIONTYPE,
} from './constants';
  
export function chooseCurrentCompanyPositionNameType(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_POSITIONTYPE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_POSITIONTYPE:
        return {
          ...state,
          currentCompanyPositionName:action.data,
        };
  
      default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentCompanyPositionNameType.js